import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { GetPersonalisedViewsDocument, LoadPinboardForTranslationDocument, useGetPinboardListQuery as _useGetPinboardListQuery, } from '../generated/graphql-types';
export const useGetPinboardListQuery = (params = {}, skip = false) => {
    const { data, error, loading } = _useGetPinboardListQuery({
        fetchPolicy: 'network-only',
        variables: { params },
        skip,
    });
    return {
        data,
        error,
        loading,
    };
};
export const useFetchPinboardDetail = () => {
    const client = useApolloClient();
    const fetchPinboardDetail = useCallback(async (id) => {
        const loadResult = await client.mutate({
            mutation: LoadPinboardForTranslationDocument,
            variables: { id },
        });
        return {
            pinboard: loadResult.data?.Pinboard__load?.pinboard,
        };
    }, [client]);
    return { fetchPinboardDetail };
};
export const useFetchPersonalisedViews = () => {
    const client = useApolloClient();
    const fetchPersonalisedViews = useCallback(async (pinboardId) => {
        const result = await client.query({
            query: GetPersonalisedViewsDocument,
            variables: { pinboardId },
            fetchPolicy: 'network-only',
        });
        if (result.errors?.length) {
            throw new Error(result.errors[0].message);
        }
        return (result.data?.getPersonalisedViews ?? []).filter((v) => !!v);
    }, [client]);
    return { fetchPersonalisedViews };
};
//# sourceMappingURL=pinboard-list-service.js.map